fragment NavBlocksLinkSectionFragment on linkSection_Entry {
  typeHandle
  startNewColumn
  links: navLinkSectionLinks {
    ... on navLinkSectionLinksBlock_Entry {
      link: linkField {
        ...LinkFragment
      }
      mobileTitle
      new
      highlight
      image {
        url
        title
      }
    }
  }
}

fragment NavBlocksImageFeatureFragment on imageFeature_Entry {
  typeHandle
  heading
  image {
    url
    title
  }
  linkField {
    ...LinkFragment
  }
}

fragment NavBlocksFragment on navBlocks_MatrixField {
  ...NavBlocksLinkSectionFragment
  ...NavBlocksImageFeatureFragment
}

fragment HelpNavFragment on helpNav_GlobalSet {
  navHeading
  links: linkList {
    ... on linkListBlock_Entry {
      linkField {
        ...LinkFragment
      }
    }
  }
}

fragment MainNavTopLevelEntryFragment on toplevel_Entry {
  typeHandle
  title
  link: navLink {
    ...LinkFragment
  }
  navBlocks {
    ...NavBlocksFragment
  }
}
